import React, { useState } from 'react'

import { PiBuildingApartmentLight } from "react-icons/pi";
import { BiShapeSquare } from "react-icons/bi";
import { FaSlideshare } from "react-icons/fa";
import { GoPasskeyFill } from "react-icons/go";
import { TbRewindForward50 } from "react-icons/tb";
import { TbRewindBackward50 } from "react-icons/tb";
import { MdCurrencyRupee } from "react-icons/md";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

import heroImg from '../../../../assets/bhutani/Conventional/conventionalHero.png'
import inner1 from '../../../../assets/bhutani/Conventional/conventional-1.jpg'
import inner2 from '../../../../assets/bhutani/Conventional/conventional-2.jpg'
import inner3 from '../../../../assets/bhutani/Conventional/conventional-3.jpg'
import inner4 from '../../../../assets/bhutani/Conventional/conventional-4.jpg'
import inner5 from '../../../../assets/bhutani/Conventional/conventional-5.jpg'

import { ImageModal } from '../../../common/ImageModal';
import { ConnectForm } from '../../../common/ConnectForm';

const ConventionalCenter = () => {
    const [openImgModal, setOpenImgModal] = useState(false)
    const innerImgs = [inner1, inner2, inner3, inner4, inner5]
    const [selectedImgIndex, setSelectedImgIndex] = useState(null);

    const points = [
        {
            icon: PiBuildingApartmentLight,
            title: 'Triple Ceiling Height Floor Banquet Space',
        },
        {
            icon: BiShapeSquare,
            title: 'Total Area 50000sqf',
        },
        {
            icon: IoMdCheckmarkCircleOutline,
            title: 'Assured Return- 24% per annum',
        },
        {
            icon: GoPasskeyFill,
            title: 'Leases Guarantee- rs.175 per sqf',
        },
        {
            icon: FaSlideshare,
            title: 'After that 25% Revenue Sharing',
        },
        {
            icon: MdCurrencyRupee,
            title: 'Payment Plan- 50:50',
        },
        {
            icon: TbRewindForward50,
            title: ' 50% on Booking',
        },
        {
            icon: TbRewindBackward50,
            title: '50% in 18 Months',
        },
    ];



    const handleOpenModal = (index) => {
        setOpenImgModal(false);
        setSelectedImgIndex(index);
        setTimeout(() => {
            setOpenImgModal(true);
        }, 100);
    };



    return (
        <div className="w-full min-h-screen bg-gray-100">
            <div
                className="w-full h-[500px] bg-cover bg-center mb-5"
                style={{ backgroundImage: `url('${heroImg}')` }}
            ></div>


            <div class="flex flex-col md:flex-row px-2.5 gap-4">
                <div class="w-full md:w-2/3 flex flex-col gap-4">
                    <div class="">
                        <div className="max-w-5xl mx-auto p-6">
                            <p className="text-md text-gray-700 mb-4 text-justify">The Luxury Banquet Halls at Bhutani City Center 32 in Noida Sector 32 are designed to elevate your events to a new
                                level of sophistication and elegance. Strategically located in the heart of Noida, these banquet spaces offer
                                unparalleled convenience and seamless accessibility for your guests.</p>
                            <p className="text-md text-gray-700 mb-4 text-justify">The banquet halls feature State-of-the-art Amenities and modern decor that exudes charm and sophistication,
                                providing the perfect backdrop for memorable moments. Whether you're planning a grand celebration, an intimate
                                ceremony, or a high-profile corporate gathering, the banquet halls at Bhutani City Center 32 are equipped to cater to
                                diverse occasions.</p>
                            <p className="text-md text-gray-700 mb-4 text-justify">With spacious layouts, versatile seating arrangements, and world-class services, every detail is carefully curated to
                                create an unforgettable experience. At Bhutani City Center 32, they don't just host events—they create memories
                                that last a lifetime.</p>
                        </div>
                        <div className="max-w-4xl mx-auto p-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {points.map((point, index) => (
                                    <div
                                        key={index}
                                        className="flex items-center bg-white p-4 rounded-lg shadow hover:shadow-lg transition-shadow duration-300"
                                    >
                                        {React.createElement(point.icon, {
                                            size: 24,
                                            color: "green",
                                            className: "w-6 h-6 mr-3",
                                        })}
                                        <span className="text-gray-700 font-medium">{point.title}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <ConnectForm />
            </div>

            {openImgModal && (
                <ImageModal
                    images={innerImgs}
                    openImg={openImgModal}
                    selectedImgIndex={selectedImgIndex}
                    onClose={() => setOpenImgModal(false)} // Close modal when clicking ✕
                />
            )}

            <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 p-4">
                {innerImgs.map((data, index) => (
                    <div
                        key={index}
                        onClick={() => handleOpenModal(index)}

                        className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
                    >
                        <img src={data} alt="Bhutani" className="w-full h-full object-cover" />
                    </div>
                ))}
            </div>

        </div>
    )
}
export default ConventionalCenter;